__webpack_require__.p = "/digital/";